const PROFILE_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Returns whether a value matches the UUID shape used for profile IDs. */
export function isProfileId(value: string): boolean {
  return PROFILE_ID_PATTERN.test(value);
}

/** Returns a valid profile ID or throws when the authenticated profile ID is malformed. */
export function assertProfileId(profileId: string): string {
  if (!isProfileId(profileId)) {
    throw new Error("Invalid authenticated profile id.");
  }

  return profileId;
}

/**
 * Returns a valid profile ID for callers that may not have an authenticated
 * profile yet, distinguishing "signed out" from "malformed profile id".
 */
export function profileIdOrThrow(profileId: string | null | undefined): string {
  if (profileId === null || profileId === undefined) {
    throw new Error("Not authenticated.");
  }

  return assertProfileId(profileId);
}
